import {html, css} from '@isceco/widget-library2/external/lit'
import '@isceco/widget-library2/basic-elements/Title/Title.js'
import '@isceco/widget-library2/basic-elements/TextInput/TextInput.js'
import '@isceco/widget-library2/basic-elements/Textarea/Textarea.js'
import '@isceco/widget-library2/basic-elements/Button/Button.js'
import '@isceco/widget-library2/basic-elements/Dropdown/Dropdown.js'
import '@isceco/widget-library2/basic-elements/Switch/Switch.js'
import WohnobjektService from '../Wohnobjekt/WohnobjektService.js'
import OrtService from './OrtService.js'
import '@isceco/widget-library2/basic-elements/Form/Form.js'
import Nutzungsanliegen from './Nutzungsanliegen.js'
import Nutzungsgruppe from './Nutzungsgruppe.js'
import MainWebComponent from '../../MainWebComponent.js'
import Land from './Land.js'

export default class WohnobjektEdit extends MainWebComponent {

  get translationFile() {
    return './views/WohnobjektEdit/i18n.json'
  }

  get css() {
    return [
      css`
        .plz > *:first-child {
          min-width: 150px;
          flex: 0;
        }

        .plz > *:last-child {
          flex: 1;
        }

        .plz-select {
          border: 1px solid var(--isceco-color-grey-700);
          background-color: var(--isceco-color-white-500);
          border-radius: 4px;
          max-height: 200px;
          overflow: auto;
        }

        .plz-select .plz {
          padding: 10px 0;
          cursor: pointer;
        }

        .plz-select .plz:hover {
          background-color: var(--isceco-color-blue-100);
        }

        .plz-select .plz > div {
          padding: 0 10px;
          box-sizing: border-box;
        }
      `
    ]
  }

  connectedCallback() {
    super.connectedCallback()
    this.orteAuswahl = []
    this.wohnobjekt = {
      'land': 'CH'
    }
    this.reload()
  }

  reload() {
    const currentId = getNavigationId()
    const wohnobjektService = new WohnobjektService()
    if (currentId === undefined) {
      this.isEdit = false
      this.isReadonly = false
      wohnobjektService.latest()
        .then(json => {
          this.wohnobjekt.nutzungsanliegen = json.nutzungsanliegen
          this.wohnobjekt.nutzungsgruppe = json.nutzungsgruppe
          this.render()
        })
    } else {
      this.isEdit = true
      wohnobjektService.read(currentId)
        .then(wohnobjekt => {
          this.wohnobjekt = wohnobjekt
          this.isReadonly = !isEmpty(wohnobjekt.gesuchStatus)
          this.render()
        })
    }
  }

  getTemplate() {
    const title = this.i18n.translate(`wohnobjekt.${this.isEdit ? 'edit' : 'create'}.header`)
    const submitCallback = this.isEdit ? this.update : this.upload
    const cancelText = this.isReadonly ?
      this.i18n.translate('wohnobjekt.form.zurueck') :
      this.i18n.translate('wohnobjekt.form.abbrechen')
    const submitText = this.isReadonly ? '' : this.i18n.translate('wohnobjekt.form.speichern')

    return html`
      <isceco-title text="${title}"></isceco-title>

      <isceco-form id="wohnobjekt-form"
                   submit-button-text="${submitText}"
                   @submit="${e => submitCallback(e.detail)}">
        <div slot="form-elements" class="form">
          <isceco-dropdown required
                           .value="${this.wohnobjekt.nutzungsanliegen}"
                           .items="${Nutzungsanliegen.ITEMS}"
                           .i18n="${this.i18n}"
                           placeholder="${this.i18n.translate('nutzungsanliegen.empty')}"
                           label="${this.i18n.translate('wohnobjekt.form.nutzungsanliegen')} *"
                           name="nutzungsanliegen"
                           ?disabled="${this.isReadonly}"
          ></isceco-dropdown>
          <isceco-dropdown required
                           .value="${this.wohnobjekt.nutzungsgruppe}"
                           .items="${Nutzungsgruppe.ITEMS}"
                           .i18n="${this.i18n}"
                           placeholder="${this.i18n.translate('nutzungsgruppe.empty')}"
                           label="${this.i18n.translate('wohnobjekt.form.nutzungsgruppe')} *"
                           name="nutzungsgruppe"
                           ?disabled="${this.isReadonly}"
          ></isceco-dropdown>
          <isceco-text-input required
                             value="${this.wohnobjekt.titel}"
                             name="titel"
                             label="${this.i18n.translate('wohnobjekt.form.titel')} *"
                             ?disabled="${this.isReadonly}"
          ></isceco-text-input>
          <isceco-dropdown required
                           label="${this.i18n.translate('wohnobjekt.form.land')} *"
                           name="land"
                           .items="${Land.ITEMS}"
                           value="${this.wohnobjekt.land}"
                           ?disabled="${this.isReadonly}"
                           @change="${this.landChanged}"
                           .i18n="${this.i18n}"
          ></isceco-dropdown>
          <div class="inline plz">
            <isceco-text-input required
                               value="${this.wohnobjekt.plz}"
                               name="plz"
                               label="${this.i18n.translate('wohnobjekt.form.plz')} *"
                               @keyup="${this.plzChanged}"
                               ?disabled="${this.isReadonly}"
            ></isceco-text-input>
            <isceco-text-input required
                               value="${this.wohnobjekt.standort}"
                               name="standort"
                               label="${this.i18n.translate('wohnobjekt.form.ort')} *"
                               @keyup="${this.ortChanged}"
                               ?disabled="${this.isReadonly}"
            ></isceco-text-input>
          </div>
          ${this.renderOrtAuswahl()}
          <isceco-textarea value="${this.wohnobjekt.beschreibung}"
                           name="beschreibung"
                           label="${this.i18n.translate('wohnobjekt.form.beschreibung')}"
                           rows="5"
                           ?disabled="${this.isReadonly}"
          ></isceco-textarea>
        </div>
        <div slot="buttons" class="inline">
          <isceco-button text="${cancelText}" @click="${_ => this.cancel()}"></isceco-button>
        </div>
      </isceco-form>

      <isceco-dialog hidden
                     id="abbrechen-dialog"
                     header="${this.i18n.translate('abbrechen.dialog.header')}"
                     description="${this.i18n.translate('abbrechen.dialog.description')}"
                     confirm-button="${this.i18n.translate('abbrechen.dialog.button.ok')}"
                     cancel-button="${this.i18n.translate('abbrechen.dialog.button.cancel')}"
                     @submit="${e => this.back(e)}"
      ></isceco-dialog>
    `
  }

  renderOrtAuswahl() {
    if (this.orteAuswahl.length > 0) {
      const orte = this.orteAuswahl.map(ort => html`
        <div class="inline plz"
             tabindex="0"
             @click="${_ => this.ortAuswaehlen(ort)}"
             @keydown="${e => this.ortAuswaehlen(ort, e)}">
          <div>${ort.plz}</div>
          <div>${ort.ort}</div>
        </div>
      `)
      return html`
        <div class="plz-select">
          ${orte}
        </div>
      `
    } else {
      return html``
    }
  }

  ortAuswaehlen = (ort, event = null) => {
    if (event && event.code !== 'Enter') {
      return
    }
    this.querySelector(`*[name='plz']`).value = ort.plz.toString()
    this.querySelector(`*[name='standort']`).value = ort.ort.toString()
    this.orteAuswahl = []
    this.render()
  }

  cancel = _ => {
    if (formChanged('#wohnobjekt-form', this.wohnobjekt)) {
      document.querySelector('#abbrechen-dialog').hidden = false
    } else {
      this.back()
    }
  }

  back = event => {
    if (event) {
      event.target.hidden = true
      if (!event.detail.confirmed) {
        return
      }
    }
    if (this.wohnobjekt.id && localStorage.getItem('hash') === 'WohnobjektDetail') {
      navigate({to: 'WohnobjektDetail', id: this.wohnobjekt.id})
    } else {
      navigate({to: 'Wohnobjekt'})
    }
  }

  upload = wohnobjekt => {
    const wohnobjektService = new WohnobjektService()
    wohnobjektService.create(wohnobjekt)
      .then(json => {
        showAlert(this.i18n.translate('wohnobjekt.create.success.title'), this.i18n.translate('wohnobjekt.create.success.body', {titel: wohnobjekt.titel}), 'success')
        navigate({to: 'WohnobjektDetail', id: json.id})
      })
  }

  update = wohnobjekt => {
    wohnobjekt.id = this.wohnobjekt.id

    const wohnobjektService = new WohnobjektService()
    wohnobjektService.update(wohnobjekt)
      .then(json => {
        showAlert(this.i18n.translate('wohnobjekt.update.success.title'), this.i18n.translate('wohnobjekt.update.success.body', {titel: wohnobjekt.titel}), 'success')
        navigate({to: 'WohnobjektDetail', id: json.id})
      })
  }

  landChanged = land => {
    if (land.target.value !== 'CH') {
      this.orteAuswahl = []
      this.render()
    }
  }

  plzChanged = plz => this.plzOrOrtChanged('plz', plz.target)

  ortChanged = ort => this.plzOrOrtChanged('ort', ort.target)

  plzOrOrtChanged = (name, target) => {
    const land = this.querySelector(`*[name='land']`).getValue()
    if (land !== 'CH' || isEmpty(target.value)) {
      return
    }
    this.orteAuswahl = []
    const ortService = new OrtService()
    ortService.readPlzOrOrt(name, target.value).then(json => {
      if (json.length === 1) {
        this.plzInput().value = json[0].plz
        this.ortInput().value = json[0].ort
      } else if (json.length > 1) {
        this.orteAuswahl = json
      }
    }).finally(_ => {
      this.render()
    })
  }

  ortInput = () => this.querySelector(`*[name='standort']`)

  plzInput = () => this.querySelector(`*[name='plz']`)
}
customElements.define('tool-frontend-wohnobjekt-edit', WohnobjektEdit)
